import Index from '@tunnel-components/@sharded/modal/changepassword/container'

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/modal/changepassword/index.ts